import { Injectable } from '@angular/core';
import { EventUtil, AppType, AppOptions } from '../../shared/frm-util';
import { FrmEventBus } from '../../eventbus/frm-evenbus';
import { Subject } from 'rxjs';


@Injectable()
export class FrameworkEventService {

    public FarrisApps = EventUtil.FARRIS_APPS;
    public FarrisAppClick = EventUtil.FARRIS_APP_CLICK;
    public AllGspFuncs = EventUtil.ALL_GSP_FUNCS;
    public BeforeFuncClose = EventUtil.BEFORE_FUNC_CLOSE;
    public FuncClosed = EventUtil.FUNC_CLOSED;
    public FuncSwitch = EventUtil.FUNC_SWITCH;
    public AfterFrameLoad = EventUtil.AFTER_FRAME_LOAD;

    constructor(private feb: FrmEventBus) {
        const eventBusEntity = EventUtil.getFrmEvent();
        if (!eventBusEntity) {
            EventUtil.setFrmEvent(this.feb || new FrmEventBus());
            this.eventInitial();
        }
    }


    public eventFire(token: string, args: any) {
        const feb = EventUtil.getFrmEvent();
        if (!feb || typeof feb.post !== 'function') {
            return;
        }
        feb.post(token, args);
    }

    public eventListner(token: string, handler: (value: any) => void, options?: AppOptions) {
        const feb = EventUtil.getFrmEvent();
        if (!feb || typeof feb.on !== 'function') {
            return;
        }
        // 菜单监听者必须要声明自己的身份，方便框架管理
        if (options && options.appType) {
            switch (options.appType.toLowerCase()) {
                case AppType.App:
                    const appObkey = EventUtil.appObsToken(options.appId, options.appEntrance, options.tabId);
                    feb.onWithObkey(token, appObkey, handler);
                    return;
                case AppType.Menu:
                    const funcObkey = EventUtil.funcObsToken(options.funcId, options.tabId);
                    feb.onWithObkey(token, funcObkey, handler);
                    return;
                default: break;
            }
        }
        feb.on(token, handler);
    }

    private eventInitial() {
        const feb = EventUtil.getFrmEvent();
        if (!feb || typeof feb.post !== 'function') {
            return;
        }
        feb.post(this.FarrisApps, null);
        feb.post(this.FarrisAppClick, null);
        feb.post(this.AllGspFuncs, null);
        feb.initialPipe(this.FuncClosed, new Subject<any>());
        feb.initialPipe(this.FuncSwitch, new Subject<any>());
        feb.initialPipe(this.BeforeFuncClose, new Subject<any>());
        feb.initialPipe(this.AfterFrameLoad, new Subject<any>());
    }

}
